import { useState, useEffect } from 'react';
import { getStickyATCElement } from '../utils/assistant-utils';

export const useStickyElementOffset = (entry) => {
  const [offsetMargin, setOffsetMargin] = useState(0);
  const [stickyAtcOffset, setAtcOffset] = useState(0);

  const getAtcOffset = () => {
    const stickyATCElement = getStickyATCElement();

    return !!stickyATCElement && !stickyATCElement.classList.contains('sui-hidden')
      ? stickyATCElement.offsetHeight : 0;
  };

  useEffect(() => {
    const targetNode = document.querySelector('#root [data-fusion-section="F"]');
    const callback = () => setAtcOffset(getAtcOffset());
    const observer = new MutationObserver(callback);

    if (targetNode) {
      observer.observe(targetNode, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let footerOffset = 0;

    footerOffset = entry?.visible && entry?.navigation?.positionBottom ? entry?.navigation.clientRect?.height : 0;

    setOffsetMargin(stickyAtcOffset > footerOffset ? stickyAtcOffset : footerOffset);
  }, [entry, stickyAtcOffset]);

  return offsetMargin;
};